import script from "./NotesView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesView.vue?vue&type=script&setup=true&lang=js"

import "./NotesView.vue?vue&type=style&index=0&id=3d3687b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3687b8"]])

export default __exports__